import { TagWebDto } from '@/features/dashboard/tags/types/TagWebDto.ts';

export const tagsExportRender = (value: unknown): string => {
  if (!Array.isArray(value)) return '';
  return (value as TagWebDto[]).map((tag) => tag.name).join(', ');
};
